/*
 *###############################################################################
 *Module Name                   : CustomerBundleMasterContent.js                #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               : Bihini Amarasinghe                            #
 *Date                          : Friday, April 21st 2022                       #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */

import React, { useState } from "react"
import { CardText, Col, Row, Alert, Button, Label } from "reactstrap"
import DPTextBox from "framework/components/DPTextBox"
import DPSwitch from "framework/components/DPSwitch"
import DPMultiSelectDropdown from "framework/components/DPMultiSelectDropdown"
import DPTextBoxButton from "framework/components/DPTextBoxButton"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"

const CustomerBundleMasterContent = ({
  CodeValue,
  CodeonChange,
  BundleNameValue,
  BundleNameOnChange,
  minimumpointValue,
  minimumpointOnChange,
  disabled,
  StatusonChange,
  AutoStatus,
  EbillonChange,
  AutoEbill,
  MobileonChange,
  AutoMobile,
  show,
  AlertMsg,
  AlertColor,
  modelOpen,
  modelTrigger,
  GetSelectRow,
  disabledCode,
  CodeOnBlur,
  ErrorMsg,
  menuName,
  onButtonClick,
  btnDisable,
  SearchDisable,
  setgenderBase,
  allDesignation,
  allProfession,
  customergroups,
  allCompany,
  setcompanyBase,
  setcustomerBase,
  setprofessionBase,
  setdesignationBase,
  profession,
  company,
  customer,
  designation,
  autoCode,
  setgender,
  gender,
  menuCode,
  minimumpointOnblur
}) => {
  //*** useState to save table data */
  //*** End of useStates */

  const [Datatablesub, SetDatatablesub] = useState([])
  const [groupFilter, SetGroupFilter] = useState('a')
  const ApiURL = window.Links.ApiURL


  async function tog_backdrop() {
    modelTrigger()
  }

  //modal props
  const columns = [{
    field: "BUN_CODE",
    title: "Code",
    align: "center",
  },
  {
    field: "BUN_DESC",
    title: "Description",
    align: "center",
  },];
  //default sorted method
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]



  return (
    <React.Fragment>
      <div>
        <Col sm="12">
          <CardText className="mb-0">
            <Row>
              {show ? (
                <Alert color={AlertColor} role="alert">
                  {AlertMsg}
                  <br />
                  <small>{ErrorMsg}</small>
                </Alert>
              ) : null}
              <Col sm={12} md={6} className="mb-4-sm">
                <DPTextBoxButton
                  rowClass="mb-4-sm"
                  labelText="Bundle Code "
                  textType="text"
                  maxLength="5"
                  value={CodeValue}
                  onChange={CodeonChange}
                  onBlur={CodeOnBlur}
                  disabled={disabled == true ? disabled : disabledCode}
                  onButtonClick={onButtonClick}
                  btnDisable={disabled == true ? disabled : btnDisable}
                  placeholder={autoCode}
                />
                <DPTextBox
                  rowClass="mb-4-sm"
                  labelText="Bundle Name"
                  textType="text"
                  maxLength="40"
                  value={BundleNameValue}
                  onChange={BundleNameOnChange}
                  disabled={disabled}
                />
                <Row>
                  <Col sm={12} md={3}>
                    <Label
                      htmlFor="example-text-input"
                      className="col-md col-form-label-sm"
                    >Company Base </Label>
                  </Col>
                  <Col sm={12} md={9} className="mb-4-sm">
                    <DPMultiSelectDropdown
                      selected={company}
                      setSelected={setcompanyBase}
                      options={allCompany}
                      labelText={"Company Base "}
                      disabled={disabled}
                      labelHide={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} md={3}>
                    <Label
                      htmlFor="example-text-input"
                      className="col-md col-form-label-sm"
                    >Customer Base </Label>
                  </Col>
                  <Col sm={12} md={9} className="mb-4-sm">
                    <DPMultiSelectDropdown
                      selected={customer}
                      setSelected={setcustomerBase}
                      options={customergroups}
                      labelText={"Customer Base "}
                      disabled={disabled}
                      labelHide={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} md={3}>
                    <Label
                      htmlFor="example-text-input"
                      className="col-md col-form-label-sm"
                    >Profession Base </Label>
                  </Col>
                  <Col sm={12} md={9} className="mb-4-sm">
                    <DPMultiSelectDropdown
                      selected={profession}
                      setSelected={setprofessionBase}
                      options={allProfession}
                      labelText={"Profession Base "}
                      disabled={disabled}
                      labelHide={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} md={3}>
                    <Label
                      htmlFor="example-text-input"
                      className="col-md col-form-label-sm"
                    >Designation Base </Label>
                  </Col>
                  <Col sm={12} md={9} className="mb-4-sm">
                    <DPMultiSelectDropdown
                      selected={designation}
                      setSelected={setdesignationBase}
                      options={allDesignation}
                      labelText={"Designation Base "}
                      disabled={disabled}
                      labelHide={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} md={3}>
                    <Label
                      htmlFor="example-text-input"
                      className="col-md col-form-label-sm"
                    >Gender Base</Label>
                  </Col>
                  <Col sm={12} md={9} className="mb-4-sm">
                    <DPMultiSelectDropdown
                      selected={gender}
                      setSelected={setgender}
                      options={setgenderBase}
                      labelText={"Gender Base"}
                      disabled={disabled}
                      labelHide={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} md={3}>
                    <Label
                      htmlFor="example-text-input"
                      className="col-md col-form-label-sm"
                    >Mobile App</Label>
                  </Col>
                  <Col sm={12} md={9} className="mb-4-sm">
                    <DPSwitch
                      rowClass={"mb-4-sm"}
                      onChange={MobileonChange}
                      checked={AutoMobile}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={12} md={3}>
                    <Label
                      htmlFor="example-text-input"
                      className="col-md col-form-label-sm"
                    >EBill</Label>
                  </Col>
                  <Col sm={12} md={9} className="mb-4-sm">
                    <DPSwitch
                      rowClass={"mb-4-sm"}
                      onChange={EbillonChange}
                      checked={AutoEbill}
                      disabled={disabled}
                    />
                  </Col>

                </Row>
                <Row>
                  <Col sm={12} md={3}>
                    <Label
                      htmlFor="example-text-input"
                      className="col-md col-form-label-sm"
                    >Status</Label>
                  </Col>
                  <Col sm={12} md={9} className="mb-4-sm">
                    <DPSwitch
                      rowClass={"mb-4-sm"}
                      onChange={StatusonChange}
                      checked={AutoStatus}
                      disabled={disabled}
                    />
                  </Col>
                </Row>
                <DPTextBox
                  rowClass="mb-4-sm"
                  labelText="Minimum Point Balance"
                  textType="text"
                  maxLength="40"
                  textAlign={"right"}
                  value={minimumpointValue}
                  onChange={minimumpointOnChange}
                  onBlur={minimumpointOnblur}
                  disabled={disabled}
                />
              </Col>

              <Col sm={12} md={4} className="mb-4-sm">
                <Button
                  onClick={() => {
                    tog_backdrop()
                  }}
                  color="success"
                  className="btn-sm"
                  disabled={SearchDisable}
                >
                  <i
                    className="mdi mdi-search-web"
                    style={{ fontSize: "12px" }}
                  ></i>
                </Button>
              </Col>

              <DPSearchBoxDynamic
                searchData={Datatablesub}
                columns={columns}
                defaultSorted={defaultSorted}
                mainTitle={menuName + " Search"}
                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                isOpen={modelOpen}
                toggle={modelTrigger}
                getSelect={GetSelectRow}
                APIURL={ApiURL}
                URLPath={"PROMOBUN"}
                MenuCode={menuCode}
                KeyVal={'CUS'}
                searchBy={'BUN_CODE'}
                FilterStr={groupFilter}
              />

            </Row>
          </CardText>
        </Col>
      </div>
    </React.Fragment>
  )
}

export default CustomerBundleMasterContent
